import { DatasetID } from './filter.model';

export enum DateFilterTab {
  LAST,
  SINCE,
  BETWEEN,
  NEXT,
}

export interface DateFilterModel {
  [key: string]: DateFilter;
}

export function addMonths(date: Date, months: number): Date {
  date.setMonth(date.getMonth() + months);
  return date;
}

export interface DateFilterPayload extends DatasetID {
  date: Date;
}

export interface DateFilterVisualTypePayload extends DatasetID {
  visualType: DateFilterTab;
}

export interface DateFilterVisualDataPayload extends DatasetID {
  visualData: VisualData;
}

export interface SetAndApplyDateFilter extends DatasetID {
  visualData: VisualData;
  visualType: DateFilterTab;
  startDate: Date;
  endDate: Date;
}

export type VisualData = [number, string];

export interface DateFilter {
  startDate: string;
  endDate: string;
  visualType: DateFilterTab;
  visualData: VisualData;
  tempStartDate: string;
  tempEndDate: string;
  tempVisualType: DateFilterTab;
  tempVisualData: VisualData;
  planningStartDate: string;
  planningEndDate: string;
  planningVisualType: DateFilterTab;
  planningVisualData: VisualData;
  tempPlanningStartDate: string;
  tempPlanningEndDate: string;
  tempPlanningVisualType: DateFilterTab;
  tempPlanningVisualData: VisualData;
}
